import React from 'react';
import styles from './styles.module.scss';
import { Button } from '@mui/material';
import { useState } from 'react';

import PropTypes from 'prop-types';
import { toast } from 'react-toastify';

import PasswordInput from '../../common/PasswordInput';
import { useTranslation } from '../../../i18n/LanguageProvider';

const UserInfo = ({ onSubmitPassword, loading }) => {
  const { t } = useTranslation();
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();

    if (confirmPassword !== password) {
      toast.error(t('auth.passwordMismatch'));
      return;
    }

    onSubmitPassword({
      password
    });
  };

  return (
    <form onSubmit={handleSubmit}>
      <div>
        <p className={styles.validationDescription}>
          {t('auth.enterNewPassword')}
        </p>
      </div>

      <PasswordInput
        className={styles.formItem}
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        fullWidth
        label={t('auth.newPassword')}
        autoComplete="new-password"
        id="password"
        ltr
      />

      <PasswordInput
        className={styles.formItem}
        value={confirmPassword}
        onChange={(e) => setConfirmPassword(e.target.value)}
        fullWidth
        label={t('auth.confirmPassword')}
        autoComplete="new-password"
        id="confirm-password"
        ltr
      />

      <Button
        fullWidth
        variant="contained"
        className={styles.formItem}
        disabled={loading}
        type="submit"
      >
        {t('settings.changePassword')}
      </Button>
    </form>
  );
};

UserInfo.propTypes = {
  onSubmitPassword: PropTypes.func,
  loading: PropTypes.bool
};

export default UserInfo;
